import Hardwood from "../Assets/services/flooring/Hardwood.jpg";
import Epoxy from "../Assets/services/flooring/Epoxy.jpg";
import Tiling from "../Assets/services/flooring/Tiling.jpg";
import Carpet from "../Assets/services/flooring/Carpet.jpg";
import FlooringRepairMaintenance from "../Assets/services/flooring/FlooringRepairMaintenance.jpg";
import interior from "../Assets/services/painting/interior.jpg";
import Decorative from "../Assets/services/painting/Decorative.jpg";
import Surface from "../Assets/services/painting/Surface.jpg";
import Basement from "../Assets/services/waterproof/Basement.jpg";
import roof from "../Assets/services/waterproof/roof.jpg";
import extwall from "../Assets/services/waterproof/Exteriorwall.jpg";
import Crawl from "../Assets/services/waterproof/Crawl.jpg";
// import pressure from "../Assets/services/plumbing/tank.png";
import pressuresystem from "../Assets/services/plumbing/pressuresystem.jpg";
import PlumbingInstallations from "../Assets/services/plumbing/PlumbingInstallations.jpg";
import leak from "../Assets/services/plumbing/leak.jpg";
import treatment from "../Assets/services/plumbing/treatment.jpg";
import Drainage from "../Assets/services/plumbing/Drainage.jpg";
import FireSuppressionSystems from "../Assets/services/safety/FireSuppressionSystems.jpg";
import firealarm from "../Assets/services/safety/firealarm.jpg";
import EmergencyLightingSystems from "../Assets/services/safety/EmergencyLightingSystems.jpg";
import SafetySignageEquipment from "../Assets/services/safety/SafetySignageEquipment.jpg";
import SmartHomeAutomation from "../Assets/services/auto/SmartHomeAutomation.jpg";
import SecuritySurveillanceSystems from "../Assets/services/auto/SecuritySurveillanceSystems.jpg";
import bms from "../Assets/services/auto/bms.jpg";
import ems from "../Assets/services/auto/ems.jpg";
import renovation from "../Assets/services/reno/reside.jpg";
import Commercialfit from "../Assets/services/reno/Commercialfit.jpg";
import construction from "../Assets/services/reno/construction.jpg";
import space from "../Assets/services/reno/space.jpg";
import Wooden from "../Assets/services/carpentry/wooden.JPG";
import custom from "../Assets/services/carpentry/custom.jpg";
import Cabinet from "../Assets/services/carpentry/cabinet.jpg";
import Metal from "../Assets/services/carpentry/metal.jpg";
import HVACInstallations from "../Assets/services/hvac/install.jpg";
import HVACMaintenance from "../Assets/services/hvac/maintain.jpg";
import DuctworkVentilation from "../Assets/services/hvac/duct.jpg";
import EnergyAuditshvac from "../Assets/services/hvac/enerfy.jpg";
import RepairTroubleshooting from "../Assets/services/hvac/repair.jpg";
import general from "../Assets/services/additional/genaral.jpg";
import EnergyAudits from "../Assets/services/additional/energy.JPG";
import SiteSurveys from "../Assets/services/additional/SiteSurveys.jpg";
import wall from "../Assets/services/painting/wall.jpg";
import FaultDetection from "../Assets/services/electro/cir.jpg";
import ElectricalInstallations from "../Assets/services/electro/ElectricalInstallations.JPG";
import LightingSolutions from "../Assets/services/electro/ligiting.JPG";
import ups from "../Assets/services/electro/ups.JPG";
import Electromechanical from "../Assets/services/electro/electromech.JPG";
// import { MdHealthAndSafety } from "react-icons/md";
import Routine from "../Assets/services/medical/routine.jpg";
import Repair from "../Assets/services/medical/repair.jpg";
import Emergency from "../Assets/services/medical/emergency.jpg";
import Compliance from "../Assets/services/medical/comp.jpg";
import Preventive from "../Assets/services/medical/prev.jpg";
import Installation from "../Assets/services/medical/install.jpg";

export const allServices = [
  {
    serviceName: "Flooring Solutions",
    id: 1,
    servicePara:
      "We offer a range of Flooring Solutions to enhance the functionality and aesthetics of your spaces. Whether you’re looking for stylish hardwood floors or durable tiles, our experts provide quality installation and repair services to suit your needs.",
    items: [
      {
        services: "Hardwood Flooring",
        serviceId: 1,
        image: Hardwood,
        desc: "Hardwood flooring adds warmth and sophistication to any space. We offer premium installation of hardwood floors, including sanding, sealing, and finishing to ensure durability and visual appeal. Choose from a wide range of wood species, finishes, and textures that match your interior design."
      },
      {
        services: "Epoxy Flooring ",
        serviceId: 2,
        image: Epoxy,
        desc: "Ideal for industrial and commercial spaces, epoxy and resin flooring provides a durable, high-performance surface that can withstand heavy foot traffic, chemicals, and machinery. We offer custom flooring solutions that are easy to clean and maintain."
      },
      {
        services: "Tiling Services",
        serviceId: 3,
        image: Tiling,
        desc: "We provide expert installation of ceramic, porcelain, and stone tiles for floors, walls, and backsplashes. Whether for kitchens, bathrooms, or commercial spaces, we ensure precise, beautiful installations that are easy to maintain and built to last."
      },
      {
        services: "Carpet & Vinyl flooring ",
        serviceId: 4,
        image: Carpet,
        desc: "Our carpet and vinyl flooring options offer comfort and durability. Whether you need soft, luxurious carpeting for your home or practical vinyl floors for your office, we provide a wide range of options to meet your needs."
      },
      {
        services: "Flooring Repair & Maintenance ",
        serviceId: 5,
        image: FlooringRepairMaintenance,
        desc: "Whether it's a scratched hardwood floor, cracked tile, or worn carpet, we provide flooring repair and maintenance services to restore your floors to their original condition. Our repair solutions help extend the life of your flooring, keeping your spaces looking fresh."
      }
    ]
  },
  {
    serviceName: "Painting & Decorative Works",
    id: 2,
    servicePara:
      "Transform the look of your property with our Painting & Decorative Works services. Whether you need a fresh coat of paint or a custom decorative finish, we offer expert solutions that improve the aesthetic value and protection of your space",
    items: [
      {
        services: "Interior & Exterior Painting  ",
        serviceId: 6,
        image: interior,
        desc: "Our professional painters provide high-quality interior and exterior painting services, using durable, long-lasting paints that withstand the elements. From residential homes to commercial buildings, we offer a variety of colors and finishes to suit every style and need"
      },
      {
        services: "Wall Finishes & Textures",
        serviceId: 7,
        image: wall,
        desc: "Add depth and character to your interiors with custom wall finishes and textured treatments. From traditional plaster to modern faux finishes, we provide a wide range of techniques to achieve unique looks for your home or office, making each space visually appealing."
      },
      {
        services: "Decorative Painting",
        serviceId: 8,
        image: Decorative,
        desc: "For a truly personalized touch, we offer decorative painting techniques like stenciling, murals, and faux finishes. These artistic details can transform any room into a focal point, adding elegance and charm to your property. "
      },
      {
        services: "Surface Preparation & Protection",
        serviceId: 9,
        image: Surface,
        desc: "Proper surface preparation ensures the longevity of any paint job. We thoroughly clean, repair, and prepare walls and ceilings before applying any paint, ensuring a smooth finish and long-term protection against wear and tear"
      }
    ]
  },
  {
    serviceName: "Water Proofing Solutions",
    id: 3,
    servicePara:
      "Our Waterproofing & Exterior Protection services ensure the longevity of your property by preventing water damage and safeguarding structures from harsh weather elements.",
    items: [
      {
        services: "Basement Waterproofing",
        serviceId: 9,
        image: Basement,
        desc: "Protect your basement from water ingress and dampness with our basement waterproofing solutions. We apply advanced techniques like exterior sealants, sump pumps, and French drains to prevent water from entering and causing mold or structural damage."
      },
      {
        services: "Roof Waterproofing",
        serviceId: 10,
        image: roof,
        desc: " Our roof waterproofing services ensure that your roof remains impervious to rainwater and leaks. We use high-quality sealants and coatings to protect your roof from the elements, reducing the need for costly repairs in the future."
      },
      
      {
        services: "Exterior Wall Treatments",
        serviceId: 11,
        image: extwall,
        desc: " To preserve the exterior of your building, we offer specialized treatments that protect walls from moisture, dirt, and extreme weather conditions. These  treatments not only prevent water damage but also enhance the building’s aesthetic appeal."
      },
      
      {
        services: "Crawl Space Encapsulation",
        serviceId: 12,
        image: Crawl,
        desc: "We offer crawl space encapsulation to keep moisture, mold, and pests out of your home. By sealing off your crawl space, we help maintain healthier indoor air quality and prevent foundation issues caused by water infiltration."
      }
    ]
  },
  {
    serviceName: "Plumbing & Water Systems",
    id: 4,
    servicePara:
      "Our Plumbing & Water Systems services cover the installation, repair, and maintenance of all plumbing systems. Whether it’s ensuring the proper flow of water in your home or maintaining complex water systems for commercial or industrial properties, we have the expertise to manage it all.",
    items: [
      {
        services: "Plumbing Installations",
        serviceId: 11,
        image: PlumbingInstallations,
        desc: "From the initial installation of pipes, faucets, and water heaters to the full setup of residential and commercial plumbing systems, our skilled plumbers ensure seamless, leak-free installations. We prioritize safety and efficiency, adhering to all industry regulations."
      },
      {
        services: "Leak Detection & Repair",
        serviceId: 12,
        image: leak,
        desc: "Leaks in your plumbing system can cause significant water damage if left unchecked. Using advanced tools such as thermal imaging cameras and acoustic leak detectors, we can accurately identify hidden leaks and provide timely repairs to prevent further damage."
      },
      {
        services: "Water Treatment Systems",
        serviceId: 13,
        image: treatment,
        desc: " Clean, safe water is essential for health and well-being. We install and maintain advanced water treatment systems, including filtration, softening, and reverse osmosis systems, ensuring that your water meets the highest standards for drinking, cooking, and bathing."
      },
      {
        services: "Drainage & Sewage Solutions",
        serviceId: 14,
        image: Drainage,
        desc: "Proper drainage and sewage systems are vital for maintaining the hygiene and safety of your property. We offer complete solutions for stormwater drainage, sewage treatment, and wastewater management, preventing blockages and flooding while maintaining efficient flow."
      },
      {
        services: "Water Pumps & Pressure Systems ",
        serviceId: 15,
        image: pressuresystem,
        desc: "If you experience inconsistent water pressure or need a system that provides water flow to multiple areas, our installation of water pumps and pressure systems will guarantee smooth water supply, even in larger or multi-story buildings."
      }
    ]
  },
  {
    serviceName: "Safety & Fire Protection",
    id: 5,
    servicePara:
      "Our Safety & Fire Protection services ensure that your property is safe from potential fire hazards and emergency situations.",
    items: [
      {
        services: "Fire Alarm Systems",
        serviceId: 16,
        image: firealarm,
        desc: "We provide fire alarm installations and maintenance services, ensuring early detection and timely alerts in case of a fire. Our systems include smoke detectors, alarms, and emergency evacuation lighting"
      },
      {
        services: "Fire Suppression Systems",
        serviceId: 17,
        image: FireSuppressionSystems,
        desc: "For added protection, we install fire suppression systems, including sprinklers and foam-based systems, to suppress fires before they escalate. These systems are essential for commercial and industrial buildings"
      },
      {
        services: "Emergency Lighting Systems",
        serviceId: 18,
        image: EmergencyLightingSystems,
        desc: "Our emergency lighting systems ensure that you have visibility during power outages or emergencies. We install reliable, long-lasting systems to help guideoccupants to safety during an evacuation"
      },
      {
        services: "Safety Signage & Equipment",
        serviceId: 19,
        image: SafetySignageEquipment,
        desc: " We provide safety signage and install fire extinguishers, emergency exits, and other safety equipment to ensure compliance with fire safety regulations."
      }
    ]
  },
  {
    serviceName: "Automation & Smart Solutions",
    id: 6,
    servicePara:
      "Our Automation & Smart Solutions help modernize your property with the latest technology, ensuring convenience, efficiency, and security.",
    items: [
      {
        services: "Smart Home Automation",
        serviceId: 18,
        image: SmartHomeAutomation,
        desc: "Transform your home with the latest smart home technology. From automated lighting and security systems to voice-controlled heating and cooling, we provide seamless integration of smart devices for ultimate convenience."
      },
      {
        services: "Building Management Systems (BMS)",
        serviceId: 19,
        image: bms,
        desc: "Our Building Management Systems help commercial clients monitor and control their building's infrastructure, including HVAC, lighting, and security, from a central interface. This improves efficiency, reduces costs, and enhances building management"
      },
      {
        services: "Security & Surveillance Systems",
        serviceId: 20,
        image: SecuritySurveillanceSystems,
        desc: "We install smart security solutions including CCTV cameras, access control systems, and alarm systems to protect your property. Integrated with your smart home or office setup, these systems provide enhanced safety and real-time monitoring."
      },
      {
        services: "Energy Management Systems",
        serviceId: 21,
        image: ems,
        desc: "Reduce energy consumption and costs with our energy management systems that monitor and control your property's energy use. We implement smart meters and controls to optimize your energy consumption, saving you money in the long run"
      }
    ]
  },
  {
    serviceName: "Renovation & Fit-Out Services",
    id: 7,
    servicePara:
      "Our Renovation & Fit-out Services help transform your space to meet your evolving needs, whether you’re refreshing a room or undertaking a full-scale renovation.",
    items: [
      {
        services: "Residential Renovation",
        serviceId: 20,
        image: renovation,
        desc: "We specialize in renovating residential spaces, including kitchens, bathrooms, and entire homes. Our team works closely with you to create functional and stylish spaces that reflect your tastes and needs."
      },
      {
        services: "Commercial Fit-outs",
        serviceId: 21,
        image: Commercialfit,
        desc: "Whether you're designing a new office, retail space, or restaurant, our commercial fit-out services deliver tailored solutions that maximize space and productivity.We handle everything from design to installation, ensuring a seamless fit for your business."
      },
      {
        services: "Space Planning & Design",
        serviceId: 22,
        image: space,
        desc: "Our experts help you plan and design efficient layouts for residential and commercial spaces. We focus on optimizing space usage, improving flow, and enhancing functionality."
      },
      {
        services: "Construction & Demolition",
        serviceId: 23,
        image: construction,
        desc: "We offer construction and demolition services to support large renovation projects. From initial demolition to rebuilding and construction, our team provides a full range of services to deliver quality results"
      }
    ]
  },
  {
    serviceName: "Carpentry & Fabrication",
    id: 8,
    servicePara:
      "Our Carpentry & Fabrication services provide custom woodworking and metal fabrication to meet your design and functional needs. Whether it’s custom furniture or structural elements, we craft solutions that blend aesthetics and practicality.",
    items: [
      {
        services: "Custom Furniture Design & Fabrication",
        serviceId: 22,
        image: custom,
        desc: "We specialize in crafting custom furniture that matches your exact style and functional needs. From modern tables and chairs to custom-built wardrobes and bookshelves, we create pieces that are both practical and aesthetically pleasing"
      },
      {
        services: "Wooden Structures & Frameworks",
        serviceId: 23,
        image: Wooden,
        desc: "Our team builds custom wooden structures, including beams, doors, windows, and ceilings, ensuring that each element is crafted to perfection. We provide structural carpentry for both new buildings and renovation projects"
      },
      {
        services: "Cabinet Making & Storage Solutions",
        serviceId: 24,
        image: Cabinet,
        desc: "We design and fabricate custom cabinets and storage units to maximize space and improve the functionality of your home or office. Whether it's a kitchen, bathroom, or living room, we provide tailored solutions that add both style and practicality."
      },
      {
        services: "Metal Fabrication",
        serviceId: 25,
        image: Metal,
        desc: "Our metal fabrication services include designing and building high-quality gates, railings, frames, and other metal structures. We use the latest techniques and materials to create durable, visually appealing products for residential and commercial applications."
      }
    ]
  },
  {
    serviceName: "Additional Services",
    id: 9,
    servicePara:
      "In addition to our primary services, we offer a wide range of Additional Servicestailored to meet the specific needs of our clients.",
    items: [
      {
        services: "General Maintenance",
        serviceId: 24,
        image: general,
        desc: "Routine maintenance ensures your systems remain in optimal condition, enhancing performance, reliability, and longevity. Regular inspections and timely care help prevent issues and keep operations running smoothly."
      },
      {
        services: " Energy Audits",
        serviceId: 25,
        image: EnergyAudits,
        desc: "Energy audits evaluate the energy consumption of a property to identify inefficiencies and recommend solutions for improvement. By analyzing systems and equipment, audits help reduce energy costs, improve performance, and promote sustainability, ensuring optimal energy usage for homes, offices, and industrial spaces."
      },
      {
        services: "Site Surveys",
        serviceId: 26,
        image: SiteSurveys,
        desc: "Site surveys involve a detailed assessment of a location to gather essential data for planning and decision-making. These surveys help evaluate site conditions, identify potential challenges, and ensure projects are executed efficiently, accurately, and safely across residential, commercial, or industrial spaces."
      }
    ]
  },
  {
    serviceName: "HVAC Systems",
    id: 10,
    servicePara:
      "Our HVAC Systems services ensure the efficient management of indoor climates, making your spaces more comfortable, energy-efficient, and environmentally friendly.",
    items: [
      {
        services: "HVAC Installations",
        serviceId: 31,
        image: HVACInstallations,
        desc: "We specialize in the installation of Heating, Ventilation, and Air Conditioning (HVAC) systems, ensuring optimal performance for residential, commercial, and industrial spaces. Our expert technicians design and install custom HVAC systems based on the size and needs of your space, ensuring maximum efficiency and comfort"
      },
      {
        services: "HVAC Maintenance & Servicing",
        serviceId: 32,
        image: HVACMaintenance,
        desc: "Regular maintenance is key to keeping your HVAC system running at its best. We offer routine servicing to clean filters, check refrigerant levels, and inspect ductwork, ensuring your system operates efficiently, reduces energy consumption, and extends its lifespan"
      },
      {
        services: "Ductwork & Ventilation",
        serviceId: 33,
        image: DuctworkVentilation,
        desc: "Proper ductwork and ventilation systems are essential for maintaining air quality and temperature control. We provide expert duct installation, repair, and cleaning services to ensure efficient airflow and optimal climate control in your space."
      },
      {
        services: "Energy Audits",
        serviceId: 34,
        image: EnergyAuditshvac,
        desc: "Through our energy audit services, we evaluate your HVAC systems to find inefficiencies and suggest cost-saving improvements. By analyzing air flow, insulation, and energy consumption, we provide solutions that help you save money on utility bills and reduce your carbon footprint."
      },
      {
        services: "Repair & Troubleshooting",
        serviceId: 35,
        image: RepairTroubleshooting,
        desc: "If your HVAC system breaks down or underperforms, we offer fast and reliable repair services. From faulty thermostats to refrigerant leaks, we identify and fix problems quickly to restore comfort in your home or office."
      }
    ]
  },
  {
    serviceName: "Electro-Mechanical Services",
    id: 11,
    servicePara:
      "Our Electrical & Electromechanical Services ensure the efficient and safe operation of electrical systems and electromechanical equipment, ranging from installation and maintenance to troubleshooting and repairs. We specialize in delivering reliable electrical solutions for homes, offices, and industrial spaces.",
    items: [
      {
        services: "Electrical Installations",
        serviceId: 33,
        image: ElectricalInstallations,
        desc: "We provide top-quality electrical installations for all types of buildings. From wiring and circuit boards to sockets, switches, and lighting systems, we ensure safe and efficient setups that meet local and international standards. Our team offers solutions for new construction projects as well as retrofits and upgrades for existing buildings."
      },
      {
        services: "Lighting Solutions",
        serviceId: 34,
        image: LightingSolutions,
        desc: "Enhance the ambiance of your spaces with our energy-efficient lighting solutions. We offer a range of designs, from functional office lighting to aesthetic solutions for homes and commercial properties. By using LED technology, we ensure long-term cost savings and reduce your environmental impact."
      },
      {
        services: "Fault Detection & Troubleshooting",
        serviceId: 35,
        image: FaultDetection,
        desc: "Our team excels in diagnosing electrical faults quickly and accurately. Using advanced diagnostic tools, we locate the root cause of issues, whether it’s a tripped circuit, faulty wiring, or malfunctioning appliances. Once identified, we provide prompt repairs to restore the function and safety of your systems"
      },
      {
        services: "UPS & Backup Systems",
        serviceId: 36,
        image: ups,
        desc: "Protect your critical operations from power outages with our Uninterrupted Power Supply (UPS) systems. We offer UPS installations for both residential and commercial properties, ensuring continuous power supply for computers, medical equipment,or industrial machinery. We also provide backup power solutions, including generators, to guarantee reliability during blackouts"
      },
      {
        services: "Electro Mechanical Maintenance",
        serviceId: 37,
        image: Electromechanical,
        desc: "We offer routine maintenance for electromechanical systems, including motors, transformers, generators, and other machinery. Regular servicing helps ensure optimal operation and prevents costly breakdowns, improving the efficiency and longevity of your systems."
      }
    ]
  },
  {
    serviceName: "Medical Equipment Maintenance Services",
    id: 12,
    servicePara:
      "Our Medical Equipment Maintenance Services ensure the reliable and safe performance of critical healthcare devices. From regular inspections and preventive maintenance to repairs and calibration, we specialize in keeping diagnostic, therapeutic, and monitoring equipment in optimal condition. Our services are designed to minimize downtime, enhance accuracy, and support seamless patient care across hospitals, clinics, and healthcare facilities.",
    items: [
      {
        services: "Routine Maintenance",
        serviceId: 33,
        image: Routine,
        desc: " Routine maintenance for medical equipment involves regular inspection, cleaning, testing, and servicing to ensure optimal performance, safety, and compliance with regulations. This includes checking functionality, replacing worn components, and maintaining records to prevent malfunctions and extend the equipment's lifespan."
      },
      {
        services: "Repair Services",
        serviceId: 34,
        image: Repair,
        desc: "Diagnosing and Repairing Temperature Inconsistencies: Providing swift and efficient repairs for temperature-related issues to ensure equipment functions accurately. Electrical and Mechanical Repairs: Fast response to electrical and mechanical problems to minimize downtime and prevent failures."
      },
      {
        services: "Emergency Support",
        serviceId: 35,
        image: Emergency,
        desc: "24/7 On-Call Assistance: Offering immediate support for breakdowns and power failures, ensuring availability around the clock."
      },
      {
        services: "Compliance Checks",
        serviceId: 36,
        image: Compliance,
        desc: "Regulatory Compliance: Ensuring that all equipment complies with health and safety regulations and standards. Detailed Maintenance and Compliance Reports: Providing in-depth reports on maintenance activities and regulatory status."
      },
      {
        services: "Preventive Care Packages",
        serviceId: 37,
        image: Preventive,
        desc: "Tailored Maintenance Plans: Customizing regular maintenance schedules based on the specific needs of your equipment. Annual Contract Discounts: Offering special pricing and discounts for clients who sign long-term maintenance contracts."
      },
      {
        services: "Installation Services",
        serviceId: 38,
        image: Installation,
        desc: "Expert Equipment Setup: Professional installation of medical refrigerators, freezers, incubators, and other critical equipment. Optimal Placement and Usage Guidance: Advising on ideal placement and usage to ensure equipment longevity and efficiency."
      }
    ]
  }
];
